import React from 'react';
import { motion } from 'framer-motion';
import { FaHtml5, FaCss3, FaJs, FaReact, FaPhp } from 'react-icons/fa';
import { SiFirebase, SiMysql, SiThreedotjs } from "react-icons/si";
import { RiSupabaseLine } from "react-icons/ri";

import Aboutscene from './Aboutscene';
import '../assets/About.css'
import Sparkles from './Sparkles';


const About: React.FC = () => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 1 }}
      className='framermotion about-container'
    >
      <Sparkles/>
      <Aboutscene/>
      <h2 style={{textAlign:"center"}}>About me</h2>
        <p className='about-text'>
            <span className='about-text-major'>French web developer</span><br/>
            Blending creative coding, game development and functional websites with a solid back-end foundation
        </p>
      <h3>Main Skills</h3>
      <div className="skills">
        
        <span data-skill='JavaScript'>
            <FaJs  title="JavaScript" />
        </span>
        <span data-skill='React'>
            <FaReact  title="React" />
        </span>
        <span data-skill='Three.js'>
            <SiThreedotjs title='Three.js'/>
        </span>
        <span data-skill='PHP'>
            <FaPhp  title="PHP" />
        </span>
        <span data-skill='mySQL'>
            <SiMysql  title='mySQL'/>
        </span>
        <span data-skill='Supabase'>
            <RiSupabaseLine  title='Supabase'/>
        </span>
        <span data-skill='Firebase'>
            <SiFirebase  title='Firebase'/>
        </span>
        <span data-skill='CSS3'>
            <FaCss3  title="CSS3" />
        </span>
        <span data-skill='HTML5'>
            <FaHtml5  title="HTML5" />
        </span>
      </div>
        <svg width="0" height="0" style={{ position: 'absolute' }}>
            <defs>
                <linearGradient id="skillGradient1" x1="0%" y1="0%" x2="100%" y2="100%">
                <stop offset="0%" stopColor="var(--text-color)" />
                <stop offset="100%"  stopColor="oklch(from var(--text-color) l c calc(h + 30))" />
                </linearGradient>
            </defs>
        </svg>
        <svg width="0" height="0" style={{ position: 'absolute' }}>
            <defs>
                <linearGradient id="skillGradient2" x1="0%" y1="0%" x2="100%" y2="100%">
                <stop offset="0%" stopColor="oklch(from var(--text-color) l c calc(h + 20))" />
                <stop offset="100%"  stopColor="oklch(from var(--text-color) l c calc(h + 50))" />
                </linearGradient>
            </defs>
        </svg>
        <svg width="0" height="0" style={{ position: 'absolute' }}>
            <defs>
                <linearGradient id="skillGradient3" x1="0%" y1="0%" x2="100%" y2="100%">
                <stop offset="0%" stopColor="oklch(from var(--text-color) l c calc(h + 40))" />
                <stop offset="100%"  stopColor="oklch(from var(--text-color) l c calc(h + 70))" />
                </linearGradient>
            </defs>
        </svg>
        <svg width="0" height="0" style={{ position: 'absolute' }}>
            <defs>
                <linearGradient id="skillGradient4" x1="0%" y1="0%" x2="100%" y2="100%">
                <stop offset="0%" stopColor="oklch(from var(--text-color) l c calc(h + 50))" />
                <stop offset="100%"  stopColor="oklch(from var(--text-color) l c calc(h + 80))" />
                </linearGradient>
            </defs>
        </svg>
        <svg width="0" height="0" style={{ position: 'absolute' }}>
            <defs>
                <linearGradient id="skillGradient5" x1="0%" y1="0%" x2="100%" y2="100%">
                <stop offset="0%" stopColor="oklch(from var(--text-color) l c calc(h + 40))" />
                <stop offset="100%"  stopColor="oklch(from var(--text-color) l c calc(h + 80))" />
                </linearGradient>
            </defs>
        </svg>
        <svg width="0" height="0" style={{ position: 'absolute' }}>
            <defs>
                <linearGradient id="skillGradient6" x1="0%" y1="0%" x2="100%" y2="100%">
                <stop offset="0%" stopColor="oklch(from var(--text-color) l c calc(h + 80))" />
                <stop offset="100%"  stopColor=" oklch(from var(--text-color) l c calc(h + 90))" />
                </linearGradient>
            </defs>
        </svg>
        <svg width="0" height="0" style={{ position: 'absolute' }}>
          <defs>
            <linearGradient id="skillGradient7" x1="0%" y1="0%" x2="100%" y2="100%">
              <stop offset="0%" stopColor=" oklch(from var(--text-color) l c calc(h + 80))" />
              <stop offset="30%" stopColor=" oklch(from var(--text-color) l c calc(h + 90))" />
              <stop offset="100%" stopColor=" oklch(from var(--text-color) l c calc(h + 90))" />
            </linearGradient>
          </defs>
        </svg>
        <svg width="0" height="0" style={{ position: 'absolute' }}>
          <defs>
            <linearGradient id="skillGradient8" x1="0%" y1="0%" x2="100%" y2="100%">
              <stop offset="0%" stopColor=" oklch(from var(--text-color) l c calc(h + 90))" />
              <stop offset="100%" stopColor="var(--text-color-hued)" />
            </linearGradient>
          </defs>
        </svg>
        <svg width="0" height="0" style={{ position: 'absolute' }}>
          <defs>
            <linearGradient id="skillGradient9" x1="0%" y1="0%" x2="100%" y2="100%">
              <stop offset="0%" stopColor="var(--text-color-hued)" />
              <stop offset="80%" stopColor="var(--text-color-hued)" />
              <stop offset="100%" stopColor=" oklch(from var(--text-color) l c calc(h + 90))" />
            </linearGradient>
          </defs>
        </svg>
        <svg width="0" height="0" style={{ position: 'absolute' }}>
          <defs>
            <linearGradient id="skillGradientInverted" x1="0%" y1="0%" x2="100%" y2="100%">
              <stop offset="0%" stopColor="var(--text-color-hued)" />
              <stop offset="100%" stopColor="oklch(from var(--text-color) l c calc(h + 50))" />
            </linearGradient>
          </defs>
        </svg>
    </motion.div>
  );
}

export default About;